<p-card class="data">
  <p-tabView class="mt-4 mb-4" [scrollable]="true" styleClass="c-bordered-tab-panel" [(activeIndex)]="activePanel"
    (onChange)="onTabChanged($event)">
    <p-tabPanel *ngFor="let graph of data.stat; let idx = index" [selected]="idx == activePanel">
      <ng-template pTemplate="header">
        {{ graph.caption }} ({{ graph.distinctN }})
      </ng-template>
      <p-panel *ngIf="graph.n > 0" header="Столбики" [toggleable]="true" [collapsed]="true" [toggler]="'header'">
        <div style="width: 100%; min-height: 450px">
          <app-structure-graph-bar [data]="graph" [percentOptimized]="3"></app-structure-graph-bar>
        </div>
      </p-panel>
      <p-panel *ngIf="graph.n > 0" header="Пончики" [toggleable]="true" [collapsed]="true" [toggler]="'header'">
        <div style="width: 100%; min-height: 450px">
          <app-structure-graph-pie [data]="graph" [percentOptimized]="3"></app-structure-graph-pie>
        </div>
      </p-panel>
      <div class="mt-3">
        <app-structure-table-prime [categoryName]="graph.caption" [stat]="graph"></app-structure-table-prime>
      </div>
    </p-tabPanel>
  </p-tabView>
</p-card>
